import React from 'react';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';
import Chip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Chip';
import MemberAlertsTooltipContent from 'Components/AdvisorApp/Header/MemberAlertsTooltip/Content';

const useStyles = buildUseStyles('MemberAlertsTooltip', (theme) => ({
  root: {
    backgroundColor: theme.palette.warning.main,
    color: 'white',
  },
}));

const MemberAlertsTooltip = () => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Tooltip
      arrow
      placement={'bottom'}
      title={<MemberAlertsTooltipContent />}
    >
      <Chip size="medium" label={'Member Alerts'} className={classes.root} />
    </Tooltip>
  );
};

MemberAlertsTooltip.defaultProps = {
};

MemberAlertsTooltip.propTypes = {
};

export default MemberAlertsTooltip;
